import { createFileRoute } from "@tanstack/react-router";
import { PrivacyPage } from "@/components/contacts/PrivacyPage";
import { privacySeo } from "@/lib/page-seo";

export const Route = createFileRoute("/privacy")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => privacySeo(loaderData?.href ?? "/privacy"),
  component: PrivacyPage,
});
